<template>
  <transition name="slide">
    <div class="filter-wrapper">
      <custom-filter-select
      class="mt-26"
        v-on:input="applyFilter()"
        v-model="filterOptions.carType"
        :options="carTypes"
      />
      <b-field class="mt-26 radio-button-wrapper">
        <b-radio
          class="width-100 m-26"
          v-model="isSuper"
          name="standard"
          native-value="0"
        >
          <span>Standard rates</span>
          <b-tooltip
            class="rate-info"
            :label="standardRateInfo"
            multilined
            v-bind="{ position: viewportWidth < 1120 ? 'is-left' : undefined }"
            
          >
          <img src="@/assets/images/icons/interface-indicator-info.png" alt="info indicator icon">
          </b-tooltip>
        </b-radio>
      </b-field>
      <b-field>
        <b-radio class="width-100 m-26 radio-button-wrapper" v-model="isSuper" name="super" native-value="1">
          <span>Super rates</span>
          <b-tooltip
            class="rate-info"
            :label="superRateInfo"
            multilined
            v-bind="{ position: viewportWidth < 1120 ? 'is-left' : undefined }"
          >
          <img src="@/assets/images/icons/interface-indicator-info.png" alt="info indicator icon">
          </b-tooltip>
        </b-radio>
      </b-field>
      <b-field v-if="expressLaneValid">
        <b-radio class="width-100 m-26 radio-button-wrapper" v-model="isSuper" name="super" native-value="2">
          <span>Express Lane</span>
          <b-tooltip
            class="rate-info"
            :label="expressRateInfo"
            multilined
            v-bind="{ position: viewportWidth < 1120 ? 'is-left' : undefined }"
          >
          <img src="@/assets/images/icons/interface-indicator-info.png" alt="info indicator icon">
          </b-tooltip>
        </b-radio>
      </b-field>
      <b-field class="my-label" label="Price">
        <b-slider
          lazy
          key="slider-1"
          :custom-formatter="(val) => 'R' + val"
          v-model="filterOptions.priceRange"
          :min="resultConstants.minStandardPrice"
          :max="resultConstants.maxSuperPrice"
          @input="applyFilter()"
          :step="1"
        ></b-slider>
        <!-- <b-slider
          v-else
          lazy
          key="slider-2"
          :custom-formatter="(val) => 'R' + val"
          v-model="filterOptions.priceRange"
          :min="resultConstants.minSuperPrice"
          :max="resultConstants.maxSuperPrice"
          @input="applyFilter()"
          :step="1"
        ></b-slider> -->
      </b-field>
      <b-field label="Seats">
        <b-slider
          lazy
          key="slider-3"
          :custom-formatter="(val) => '' + val"
          v-model="filterOptions.seatRange"
          :min="resultConstants.minSeats"
          :max="resultConstants.maxSeats"
          @input="applyFilter()"
          :step="1"
        ></b-slider>
      </b-field>
      <b-field label="Doors">
        <b-slider
          lazy
          key="slider-4"
          :custom-formatter="(val) => '' + val"
          v-model="filterOptions.doorRange"
          :min="resultConstants.minDoors"
          :max="resultConstants.maxDoors"
          @input="applyFilter()"
          :step="1"
        ></b-slider>
      </b-field>

      <label class="custom-checkbox first-checkbox">
          <input type="checkbox" v-model="filterOptions.automatic" @change="applyFilter"/>
          <span class="checkmark"></span>
          Automatic
      </label>

      <label class="custom-checkbox">
          <input type="checkbox" v-model="filterOptions.airbags" @change="applyFilter"/>
          <span class="checkmark"></span>
          Airbags
      </label>

      <label class="custom-checkbox">
          <input type="checkbox" v-model="filterOptions.abs" @change="applyFilter"/>
          <span class="checkmark"></span>
          ABS
      </label>

      <label class="custom-checkbox">
          <input type="checkbox" v-model="filterOptions.powersteering" @change="applyFilter"/>
          <span class="checkmark"></span>
          Power steering
      </label>

    </div>
  </transition>
</template>

<script>
import VueSlider from "vue-slider-component";
import CustomFilterSelect from "@/components/CustomFilterSelect.vue";
import "vue-slider-component/theme/default.css";
import { mapState } from "vuex";
import { Cars } from "@/services/Car.service.js";

// Express Lane is not offered for these groups on the search results.
const expressExcludedGroups = ["M", "Y", "O", "H", "J", "I", "N1"];

// Fleet labels look like "6 500". Also accept a currency sign or "R6 500".
export function parseExcessAmount(label) {
  if (label == null || String(label).trim() === "") {
    return null;
  }
  const numeric = String(label).replace(/[^\d.-]/g, "");
  if (numeric === "" || numeric === "-" || numeric === "." || numeric === "-.") {
    return null;
  }
  const value = Number(numeric);
  return Number.isFinite(value) ? value : null;
}

export function lowestExcessLabel(cars, rateKey, expressOnly = false) {
  let lowestLabel = null;
  let lowestValue = null;
  for (const car of cars) {
    if (expressOnly && expressExcludedGroups.includes(car.group)) {
      continue;
    }
    const label = car.excess && car.excess[rateKey];
    const value = parseExcessAmount(label);
    if (value == null) {
      continue;
    }
    if (lowestValue == null || value < lowestValue) {
      lowestValue = value;
      lowestLabel = label;
    }
  }
  return lowestLabel;
}

export default {
  name: "filters",
  data: function () {
    return {
      filterIsOpen: false,
      isSuper: '0',
      carTypes: ["All", "Economy", "Luxury", "SUV", "4x4", "Minivan", "Light Trucks"],
      filterOptions: {
        carType: "All",
        doorRange: [0, 1],
        seatRange: [0, 1],
        priceRange: [0, 1],
        isSuper: '0',
        automatic: false,
        powersteering: false,
        abs: false,
        airbags: false,
      },
      viewportWidth: 0,
    };
  },
  computed: {
    ...mapState(["searchParameters", "cars", "expressLaneValid", "lastFilterOptions"]),
    standardRateInfo() {
      return `200km per day and excess of R${this.minimumExcess("standard")}+`;
    },
    superRateInfo() {
      return `Unlimited mileage and excess of R${this.minimumExcess("super")}+`;
    },
    expressRateInfo() {
      return `No paperwork at pick up. Unlimited mileage, tyre and windscreen cover and excess of R${this.minimumExcess("expressLane", true)}+ (Virtual cards not accepted for payment.)`;
    },
    // calculate complex properties of the returned cars
    resultConstants() {
      let minStandardPrice = 0;
      let maxStandardPrice = 1;
      let minSuperPrice = 0;
      let maxSuperPrice = 1;
      let minExpressPrice = 0;
      let maxExpressPrice = 1;
      let minDoors = 0;
      let maxDoors = 1;
      let minSeats = 0;
      let maxSeats = 1;
      let cars = this.cars.all;
      for (let i = 0; i < cars.length; ++i) {
        // find the price Range
        let currentStandardPrice = cars[i].defaultDailyCharge;
        if (minStandardPrice == 0) {
          minStandardPrice = currentStandardPrice;
          maxStandardPrice = currentStandardPrice;
        } else if (currentStandardPrice < minStandardPrice) {
          minStandardPrice = currentStandardPrice;
        } else if (currentStandardPrice > maxStandardPrice) {
          maxStandardPrice = currentStandardPrice;
        }
        // or the super rate price range
        let currentSuperPrice = cars[i].superDailyCharge;
        if (minSuperPrice == 0) {
          minSuperPrice = currentSuperPrice;
          maxSuperPrice = currentSuperPrice;
        } else if (currentSuperPrice < minSuperPrice) {
          minSuperPrice = currentSuperPrice;
        } else if (currentSuperPrice > maxSuperPrice) {
          maxSuperPrice = currentSuperPrice;
        }
        // or the express lane price range
        let currentExpressPrice = cars[i].expressDailyCharge;
        if (currentExpressPrice < minSuperPrice) {
          minSuperPrice = currentExpressPrice;
        } else if (currentExpressPrice > maxSuperPrice) {
          maxSuperPrice = currentExpressPrice;
        }
        // find the door range
        let currentDoors = cars[i].doors;
        if (minDoors == 0) {
          minDoors = currentDoors ? currentDoors : 2;
          maxDoors = currentDoors ? currentDoors : 4;
        } else if (currentDoors < minDoors) {
          minDoors = currentDoors;
        } else if (currentDoors > maxDoors) {
          maxDoors = currentDoors;
        }
        // find the seat range
        let currentSeat = cars[i].seats;
        if (minSeats == 0) {
          minSeats = currentSeat ? currentSeat : 2;
          maxSeats = currentSeat ? currentSeat : 4;
        } else if (currentSeat < minSeats) {
          minSeats = currentSeat;
        } else if (currentSeat > maxSeats) {
          maxSeats = currentSeat;
        }
      }
      return {
        minStandardPrice: minStandardPrice,
        maxStandardPrice: maxStandardPrice,
        minSuperPrice: minSuperPrice,
        maxSuperPrice: maxSuperPrice,
        minExpressPrice: minExpressPrice,
        maxExpressPrice: maxExpressPrice,
        minSeats: minSeats,
        maxSeats: maxSeats,
        minDoors: minDoors,
        maxDoors: maxDoors,
      };
    },
  },
  methods: {
    closeFilters() {
      this.$store.commit("filterCars", this.filterOptions);
      this.filterIsOpen = false;
    },
    openFilters() {
      this.filterIsOpen = true;
    },
    applyFilter() {
      this.$store.commit("filterCars", this.filterOptions);
      this.$store.commit("setRateType", this.isSuper);
    },
    updateWidth() {
      this.viewportWidth = window.innerWidth;
    },
    // Lowest excess shown for this rate type on the search results.
    minimumExcess(rateKey, expressOnly = false) {
      return lowestExcessLabel(Cars, rateKey, expressOnly);
    },
  },
  mounted() {
    this.filterOptions.carType = this.$store.state.searchParameters.carType;
    this.filterOptions.priceRange = [
      this.resultConstants.minStandardPrice,
      this.resultConstants.maxSuperPrice,
    ];
    this.filterOptions.doorRange = [
      this.resultConstants.minDoors,
      this.resultConstants.maxDoors,
    ];
    this.filterOptions.seatRange = [
      this.resultConstants.minSeats,
      this.resultConstants.maxSeats,
    ];
    if (this.lastFilterOptions) {
      this.filterOptions = this.lastFilterOptions;
      this.isSuper = this.lastFilterOptions.isSuper;

      if (this.lastFilterOptions.isSuper == '2' && !this.expressLaneValid) {
        this.isSuper = '0';
      }
    }
    this.applyFilter();
    if (this.isSuper == "1" || this.isSuper == "2") {
          this.filterOptions.priceRange = [
            this.resultConstants.minSuperPrice,
            this.resultConstants.maxSuperPrice,
          ];
          this.applyFilter();
        } else {
          this.filterOptions.priceRange = [
            this.resultConstants.minStandardPrice,
            this.resultConstants.maxStandardPrice,
          ];
        }
  },
  created() {
    window.addEventListener('resize', this.updateWidth);
    this.updateWidth();
  },
  destroyed() {
    window.removeEventListener('resize', this.updateWidth);
  },
  watch: {
    isSuper: {
      handler(newVal) {
        this.filterOptions.isSuper = newVal;
        if (newVal == "1" || newVal == "2") {
          this.filterOptions.priceRange = [
            this.resultConstants.minSuperPrice,
            this.resultConstants.maxSuperPrice,
          ];
          this.applyFilter();
        } else {
          this.filterOptions.priceRange = [
            this.resultConstants.minStandardPrice,
            this.resultConstants.maxStandardPrice,
          ];
        }
      },
    },
  },
  components: {
    VueSlider,
    CustomFilterSelect,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";

.filters-wrapper {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background: black;
  opacity: 0.1;
  z-index: 103;
}

.mt-26 {
  margin-top: 26px;
}

.filter-wrapper {
  * + * {
    margin-bottom: 22px !important;
  }
}

.width-100 {
  width: 100%;
}

.rate-info {
  position: absolute;
  right: 0;
}

.filters {
  z-index: 104;
  overflow: scroll;
  background: linear-gradient(
      144.49deg,
      rgba(255, 255, 255, 0.2) -3.36%,
      rgba(255, 255, 255, 0) 156.87%
    ),
    #f2f2f2;
  padding-top: 1.5em;
  * + * {
    margin-top: 0.75em;
  }
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 25%;
  box-shadow: 8px 10px 8px -8px #888;
  .filter-category {
    display: flex;
    padding: $standard-padding;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    font-size: 1.1em;
    width: 100%;
    color: black;
    h2 {
      font-weight: bold;
      font-size: 1.3em;
      margin: 0 0 0.4em 0;
    }
    form {
      padding: $standard-padding;
    }
    .filter-item {
      text-align: left;
      margin-bottom: $standard-padding;
      span {
        font-size: 0.6em;
        color: darken($primary-dark, 30%);
        vertical-align: middle;
      }
    }
  }
}

.toggle-filters {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 1.2em;
  padding: $standard-padding;
  color: darken($primary-dark, 30%);
  i {
    margin-left: $standard-padding;
  }
}

.slide-enter-active {
  animation: slide-in-right 0.2s cubic-bezier(1, 0.5, 0.8, 1) both;
}

.slide-leave-active {
  animation: slide-in-right 0.2s cubic-bezier(1, 0.5, 0.8, 1) both reverse;
}
</style>

<style lang="scss">
@import "@/assets/styles/variables.scss";

.b-slider .b-slider-tick-label {
  font-size: 0.75rem;
  position: absolute;
  top: 0.75em !important;
}

.b-slider .b-slider-thumb-wrapper .b-slider-thumb {
  border-radius: 100% !important;
}

.b-slider .b-slider-fill {
  background: #AC6411 !important;
}

.b-slider.is-primary .b-slider-fill {
  background: #AC6411 !important;
}

.my-label .label {
  font-size: 28px !important;
  font-weight: 500 !important;
  color: #02214d;
}

.select.is-fullwidth select {
  background: $cararra !important;
}

.b-checkbox.checkbox input[type="checkbox"] + .check {
  border-radius: 100% !important;
}

.custom-checkbox {
  display: block;
  position: relative;
  padding-left: 35px;
  cursor: pointer;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  user-select: none;
}

.custom-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #ffffff;
  border-radius: 50%;
  border: 2px solid #97989A;
}

.custom-checkbox input:checked ~ .checkmark {
  background-color: #ffffff;
  border: 2px solid #30384A;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.custom-checkbox input:checked ~ .checkmark:after {
  display: block;
}

.custom-checkbox .checkmark:after {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);  // Shift it back by half of its own width and height
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #30384A;
}
.custom-checkbox:hover .checkmark {
  border-color: black;
}

.first-checkbox {
    margin-top: 32px;
}

@media (max-width: 1120) {
  .radio-button-wrapper, .radio-button-wrapper label.b-radio{
    margin-bottom: 0 !important;
  }
}
</style>
